import {
  CargoInsuranceCancellationRequest,
  CargoInsuranceCertificate,
  CargoInsuranceProviderCommodity,
  CargoInsuranceProviderEquipmentType,
  CargoInsuranceQuote,
  CargoInsuranceQuoteRequest,
  Contact,
} from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment';

export class ShipmentCargoInsuranceController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getQuote(
    shipmentId: number,
    cargoInsuranceShipmentQuoteRequest: CargoInsuranceQuoteRequest,
  ): Promise<CargoInsuranceQuote> {
    const response = await this.http.post<CargoInsuranceQuote>(
      `/${shipmentId}/cargo-insurance/quote`,
      cargoInsuranceShipmentQuoteRequest,
    );
    return new CargoInsuranceQuote(response.data);
  }

  async purchase(
    shipmentId: number,
    corsairShipmentCargoInsuranceId: number,
    commodityExclusionAcknowledgements: Record<string, boolean>,
    termsAndConditionsAcknowledgement: boolean,
  ): Promise<CargoInsuranceCertificate> {
    const request = {
      shipmentId,
      corsairShipmentCargoInsuranceId,
      commodityExclusionAcknowledgements,
      termsAndConditionsAcknowledgement,
      additionalAuthorizedUsers: [],
    };
    const response = await this.http.post<CargoInsuranceCertificate>(
      `/${shipmentId}/cargo-insurance/${corsairShipmentCargoInsuranceId}/purchase`,
      request,
    );
    return new CargoInsuranceCertificate(response.data);
  }

  async getCertificateForShipment(
    shipmentId: number,
  ): Promise<CargoInsuranceCertificate> {
    const response = await this.http.get<CargoInsuranceCertificate>(
      `/${shipmentId}/cargo-insurance/certificate`,
    );
    return new CargoInsuranceCertificate(response.data);
  }

  async cancelCargoInsurance(
    shipmentId: number,
    corsairShipmentCargoInsuranceId: number,
    cargoInsuranceCancellationRequest: CargoInsuranceCancellationRequest,
  ): Promise<CargoInsuranceCertificate> {
    const response = await this.http.post<CargoInsuranceCertificate>(
      `/${shipmentId}/cargo-insurance/${corsairShipmentCargoInsuranceId}/cancel`,
      cargoInsuranceCancellationRequest,
    );
    return new CargoInsuranceCertificate(response.data);
  }

  async getContactsForInsurance(shipmentId: number): Promise<Contact[]> {
    const response = await this.http.get<Contact[]>(
      `/${shipmentId}/cargo-insurance/contact/insured`,
    );
    return response.data.map((c) => new Contact(c));
  }

  async getEquipment(
    shipmentId: number,
  ): Promise<CargoInsuranceProviderEquipmentType[]> {
    const response = await this.http.get<CargoInsuranceProviderEquipmentType[]>(
      `/${shipmentId}/cargo-insurance/equipment`,
    );
    return response.data.map((equipment) => ({ ...equipment }));
  }

  async getCommodities(
    shipmentId: number,
  ): Promise<CargoInsuranceProviderCommodity[]> {
    const response = await this.http.get<CargoInsuranceProviderCommodity[]>(
      `/${shipmentId}/cargo-insurance/commodities`,
    );
    return response.data.map((c) => ({ ...c }));
  }
}
